import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Input, Row, Table, message } from 'antd'
import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined'
import personalizacionTicketSrc from '../personalizacionTicket/personalizacionTicketSrc'
import LoadMoreButton from '../../../../../components/LoadMoreButton'
import Utils from '../../../../../utils/Utils'
import PersonalizacionSidebarDrawer from './personalizacionSidebarDrawer'

const { Search } = Input

export const PersonalizacionSidebar = () => {
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [dataSource, setDataSource] = useState([])
  const [nextPage, setNextPage] = useState('')
  const [existMoreInfo, setExistMoreInfo] = useState(false)
  const [editDataDrawer, setEditDataDrawer] = useState(null)

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadData = () => {
    setLoading(true)
    setVisible(false)
    personalizacionTicketSrc
      .readCompanies('', 5, true, 'desc')
      .then(result => {
        setDataSource(getCompanies(result))
        setNextPage(result.data.next_page_url)
        setExistMoreInfo(result.data.next_page_url !== null)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información')
      })
  }

  const getCompanies = dataSrc => {
    if (dataSrc !== 'Too Many Attempts.') {
      let _dataSrc = dataSrc.data.data || []
      return _dataSrc.map((d, i) => ({
        key: i,
        id: d.id,
        name: d.name,
        sidebar_logo: d.sidebar_logo,
        accent_color: d.accent_color,
        sidebar_background_color: d.sidebar_background_color,
        sidebar_text_color: d.sidebar_text_color,
      }))
    } else {
      message.error('Se excedió el límite de peticiones, espera y recarga la aplicación')
    }
  }

  const moreInfo = () => {
    if (existMoreInfo) {
      setLoading(true)
      Utils.getNextPage(nextPage)
        .then(response => {
          setDataSource(dataSource.concat(getCompanies(response)))
          setNextPage(response.data.next_page_url)
          setExistMoreInfo(response.data.next_page_url !== null)
          setLoading(false)
        })
        .catch(err => {
          console.log(err)
          message.error('No se ha podido cargar la información')
        })
    }
  }

  const searchText = value => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(value)
    personalizacionTicketSrc
      .readCompanies(value, 5, excludeChars, 'desc')
      .then(result => {
        setDataSource(getCompanies(result))
        setNextPage(result.data.next_page_url)
        setExistMoreInfo(result.data.next_page_url !== null)
        setLoading(false)
      })
  }

  const EditRow = data => {
    setVisible(true)
    setEditDataDrawer(data)
  }

  const onClose = () => {
    setVisible(false)
  }

  const onSaveButton = (companyId, data) => {
    personalizacionTicketSrc
      .updateCompanyTicketPersonalization(companyId, data)
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          Utils.checkErrors(res)
        } else {
          message.success('Información actualizada.')
          loadData()
        }
      })
      .catch(e => {
        console.log(e)
        message.error('Error al actualizar la información.')
      })
  }

  const columns = [
    {
      title: 'Empresa',
      dataIndex: 'name',
      key: 'name',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Logo del sidebar',
      dataIndex: 'sidebar_logo',
      key: 'sidebar_logo',
      render: logo => (logo ? <img src={logo} alt="Logo" style={{ maxWidth: '60px', maxHeight: '40px' }} /> : <span>{'Por defecto'}</span>),
    },
    {
      title: 'Color de acento',
      dataIndex: 'accent_color',
      key: 'accent_color',
      render: color => (
        <span>
          <span style={{ display: 'inline-block', width: 14, height: 14, borderRadius: '50%', background: color || '#01c01e', marginRight: 6, verticalAlign: 'middle' }} />
          {color || '#01c01e (por defecto)'}
        </span>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      key: 'actions',
      align: 'right',
      render: (id, row) => (
        <Button type="link" onClick={() => EditRow(row)}>
          Editar
        </Button>
      ),
    },
  ]

  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Search
            className={'customSearch'}
            prefix={<SearchOutlined className={'tendero-table-search-icon'} />}
            placeholder="Presiona enter para buscar"
            style={{ width: '40%', height: '40px' }}
            size={'large'}
            onSearch={searchText}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card className={'card-border-radius margin-top-15'}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Table loading={loading} className={'CustomTableClass'} dataSource={dataSource} columns={columns} pagination={false} rowKey="id" />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <LoadMoreButton handlerButton={moreInfo} moreInfo={existMoreInfo} />
      <PersonalizacionSidebarDrawer closable={onClose} visible={visible} editData={editDataDrawer} cancelButton={onClose} saveButton={onSaveButton} />
    </>
  )
}
